import {
  SAVE_ITEM_EDITION,
  ITEM_HISTORY,
  ITEM_HISTORY_DOWNLOAD_CSV } from '@/brain/record/stock'

const state = {}
const getters = {}
const mutations = {}
const actions = {
  SAVE_ITEM_EDITION,
  ITEM_HISTORY,
  ITEM_HISTORY_DOWNLOAD_CSV
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/record/stock/state/index.js